import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CmDropdownComponent} from './cm-dropdown.component';

@Component({
  selector: 'cm-button-dropdown',
  template: `
    <cm-dropdown #dropdown [tooltip]="tooltip" [header]="header" (toggleDropdown)="toggleDropdown.emit($event)">
      <cm-dropdown-trigger>
        <button mat-icon-button [color]="color">
          <i class="far fa-{{icon}}"></i>
        </button>
      </cm-dropdown-trigger>
      <ng-content></ng-content>
    </cm-dropdown>
  `,
})
export class CmButtonDropdownComponent {
  @ViewChild(CmDropdownComponent, { static: true }) dropdown: CmDropdownComponent;

  @Input() public header: string;
  @Input() public tooltip: string;
  @Input() public icon: string;
  @Input() public color = 'primary';
  @Output() toggleDropdown = new EventEmitter<boolean>();

  constructor() {
  }

  hide() {
    this.dropdown.close();
  }
}
